import * as React from "react";
const SvgBars = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 3H0V1h11zM7 7H0V5h7zM3 11H0V9h3z", clipRule: "evenodd" }));
export default SvgBars;
